var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("svgImage", {
    attrs: { name: "pricing-discount-" + _vm.normalizedLang },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }